module.exports = ".tarjeta {\n  width: 100%;\n  height: 100%;\n  color: white;\n  border-radius: 25px 25px 25px 25px;\n  -webkit-box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75);\n  box-shadow: 0px 5px 5px 0px rgba(50, 50, 50, 0.75); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/categorias-gastos/categoria-gasto-tarjeta/categoria-gasto-tarjeta.component.scss
// module id = ./src/app/administracion/categorias-gastos/categoria-gasto-tarjeta/categoria-gasto-tarjeta.component.scss
// module chunks = main